import {Link} from 'react-router-dom'

export default function OptionBtn({ icon, msg, path }, key, platform){
    let buttonSize; 
    switch (platform) {
    case 'mobile':
        buttonSize = 'h5';
        break; 
    default:
        buttonSize = 'h1';
        break; 
    }

    return (
        <Link to={path} className="optionBtn position-absolute d-flex flex-column p-2 px-3 p-sm-3" style={{minWidth: (buttonSize === 'h1'? '13rem':'')}} key={key}>
            <div className={`fa fa-${icon} align-self-center ${buttonSize}`}></div>
            <div className={`rocky m-0 mt-sm-3 ${buttonSize}`}>{msg}</div>
        </Link>
    )
}